import { createPortal } from "react-dom";
import { Button } from "./ui/button";
import { Printer, X } from "lucide-react";

const fmt = (d) => (d ? new Date(d).toLocaleDateString("en-CA") : "—");

export const BulkPPMPrint = ({ devices, onClose }) => {
  if (!devices) return null;

  return createPortal(
    <div className="bulk-ppm-root" data-testid="bulk-ppm-overlay">
      <style>{`
        .bulk-ppm-root {
          position: fixed;
          inset: 0;
          background: rgba(15, 15, 20, 0.6);
          z-index: 100;
          display: flex;
          flex-direction: column;
          align-items: center;
          overflow-y: auto;
          padding: 24px;
        }
        .bulk-ppm-toolbar { position: sticky; top: 0; z-index: 2; display: flex; gap: 8px; margin-bottom: 16px; }
        .bulk-ppm-labels { display: flex; flex-direction: column; gap: 10px; align-items: center; }
        .ppm-label-bulk {
          width: 40mm;
          height: 22mm;
          background: #fff;
          border-radius: 3px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 1.2mm 1.5mm;
          direction: ltr;
          overflow: hidden;
          color: #0A0A0A;
          transform: scale(2);
          transform-origin: center;
          margin: 12mm 0;
        }
        .ppm-label-bulk .ppm-row1 { display: flex; align-items: center; gap: 1mm; border-bottom: 0.3mm solid #0A0A0A; padding-bottom: 0.5mm; }
        .ppm-label-bulk .ppm-tag { font-size: 6pt; font-weight: 800; letter-spacing: 0.5px; border: 0.3mm solid #0A0A0A; padding: 0 0.8mm; line-height: 1.4; flex-shrink: 0; }
        .ppm-label-bulk .ppm-name { font-size: 5.5pt; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; }
        .ppm-label-bulk .ppm-line { font-family: 'Courier New', monospace; font-size: 5.5pt; font-weight: 700; line-height: 1.3; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .ppm-label-bulk .ppm-dates { display: flex; justify-content: space-between; gap: 1mm; }
        .ppm-label-bulk .ppm-date { font-size: 5pt; font-weight: 700; line-height: 1.3; }
        .ppm-label-bulk .ppm-date span { display: block; font-size: 4.5pt; font-weight: 600; color: #333; }
        @media print {
          @page { size: 40mm 22mm; margin: 0; }
          #root { display: none !important; }
          html, body { width: 40mm !important; margin: 0 !important; padding: 0 !important; }
          .bulk-ppm-root, .bulk-ppm-root * { visibility: visible !important; }
          .bulk-ppm-root { position: static !important; background: none !important; padding: 0 !important; overflow: visible !important; display: block !important; }
          .bulk-ppm-toolbar { display: none !important; visibility: hidden !important; }
          .bulk-ppm-labels { display: block !important; }
          .ppm-label-bulk {
            border-radius: 0 !important;
            transform: none !important;
            margin: 0 !important;
            page-break-after: always;
            break-after: page;
          }
          .ppm-label-bulk:last-child { page-break-after: auto; break-after: auto; }
        }
      `}</style>

      <div className="bulk-ppm-toolbar no-print">
        <Button onClick={() => window.print()} className="bg-[#655dc6] hover:bg-[#5449a8] text-white gap-2" data-testid="bulk-ppm-print-btn">
          <Printer className="w-4 h-4" /> طباعة الكل ({devices.length})
        </Button>
        <Button variant="outline" onClick={onClose} className="bg-white gap-1" data-testid="bulk-ppm-close-btn">
          <X className="w-4 h-4" /> إغلاق
        </Button>
      </div>

      <div className="bulk-ppm-labels">
        {devices.map((d) => (
          <div key={d.id} className="ppm-label-bulk">
            <div className="ppm-row1">
              <div className="ppm-tag">PPM</div>
              <div className="ppm-name">{d.device_name}</div>
            </div>
            <div className="ppm-line">No: {d.biomed_no}</div>
            <div className="ppm-line">SN: {d.serial_no || "—"}</div>
            <div className="ppm-dates">
              <div className="ppm-date"><span>PPM Date</span>{fmt(d.latest_evaluation_at)}</div>
              <div className="ppm-date"><span>Next PPM</span>{fmt(d.next_evaluation_available_at)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>,
    document.body
  );
};
